import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useAppointments } from '../../context';
import Sending from './Sending';
import SendSuccess from './SendSuccess';
import SendError from './SendError';

const Send = () => {
  const { setNewAppointmentResult } = useAppointments();
  const { new: newAppointment } = useSelector(state => state.appointments);
  const [sendStatus, setSendStatus] = useState('SENDING');

  const { sending, id, error } = useMemo(() => newAppointment, [
    newAppointment,
  ]);

  useEffect(() => {
    if (sending) {
      setSendStatus('SENDING');
    } else {
      if (id) {
        setSendStatus('SUCCESS');
        setNewAppointmentResult('SUCCESS');
      }
      if (error) {
        setSendStatus('ERROR');
        setNewAppointmentResult('ERROR');
      }
    }
    return () => {
      setNewAppointmentResult(null);
    };
  }, [sending, id, error, setNewAppointmentResult]);

  return (
    <>
      {sendStatus === 'SENDING' && <Sending />}
      {sendStatus === 'SUCCESS' && <SendSuccess />}
      {sendStatus === 'ERROR' && <SendError />}
    </>
  );
};

export default Send;
